import RegistrationModel from "../model/RegistrationModel";
import ResearcherInstitute
  from "../../../../framework/component/form/input-types/ResearcherInstitute";
import {useFieldArray, useFormContext} from "react-hook-form";
import Row from "react-bootstrap/Row";
import {Button, Form} from "react-bootstrap";
import Col from "react-bootstrap/Col";
import {InstituteSelection} from "../../../../framework/util/InstituteUtils";

export default function Institutes() {
  const {control, getValues} = useFormContext<RegistrationModel>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "institutes.otherInstitutes"
  });

  const defaultInstituteName = getValues("institutes.primaryInstitute.instituteName");
  return <>
    <ResearcherInstitute<RegistrationModel>
      label="Primary Institute"
      fieldId={"institutes.primaryInstitute"}
      primary
      defaultInstitute={defaultInstituteName ? {
        id: getValues("institutes.primaryInstitute.instituteId"),
        name: getValues("institutes.primaryInstitute.instituteName")
      } as InstituteSelection : undefined}
    />
    <Form.Group as={Row} className={"mb-2"} controlId={`formHorizontalInstitute`}>
      <Row>
        <Col sm={2}></Col>
        <Col sm={10} className={"question-help-text"}>
          Please add any other institute(s) at which you plan to use UK Biobank Resources.
        </Col>
      </Row>
    </Form.Group>
    {fields.map((field, i) =>
      <ResearcherInstitute<RegistrationModel>
        label={"Additional institute"}
        fieldId={`institutes.otherInstitutes.${i}`}
        deleteInstitute={() => remove(i)}
        key={`researcherInstitute${i}`}
      />
    )}
    <Form.Group as={Row} className="mb-2">
      <Form.Label column sm={2}>
      </Form.Label>
      <Col sm={8}>
        <Button variant="primary" onClick={() => append({
          instituteId: -1,
          email: "",
          position: "",
          department: ""
        })}>
          <i className="bi bi-plus-circle"/> Add institute
        </Button>
      </Col>
    </Form.Group>
  </>
}